import type { Locale } from 'antd/es/locale';
import localeEN from 'antd/es/locale/en_US';
import localeES from 'antd/es/locale/es_ES';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { LocaleConfig } from './config';
import { isAppLanguage } from './isAppLanguage';
import { type AppLanguage, appLanguages, supportedAppLanguagesNames } from './supported-app-languages-names';

const antdLocales: Record<AppLanguage, LocaleConfig<Locale>> = {
  [appLanguages.english]: {
    locale: localeEN,
    name: supportedAppLanguagesNames[appLanguages.english].name,
  },
  [appLanguages.spanish]: {
    locale: localeES,
    name: supportedAppLanguagesNames[appLanguages.spanish].name,
  },
};

export const useAntdLocale = () => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const antdLocale = isAppLanguage(i18n.language)
      ? antdLocales[i18n.language].locale
      : antdLocales[appLanguages.english].locale;

    return antdLocale;
  }, [i18n.language]);
};
